import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import $ from "jquery";
import { ToastrService } from "ngx-toastr";
import { forkJoin } from "rxjs";
import { Menus, SubmenuI } from "src/app/data/navigation";
import { ChatService } from "src/app/services/chat.service";
import { TeamsService } from "src/app/services/crew-services/teams.service";
import { CurrencyService } from "src/app/services/currency.service";
import { GeneralService } from "src/app/services/general.service";
import { EmailClientService } from "src/app/services/integrations/email/email-client.service";
import { EmailService } from "src/app/services/integrations/email/email.service";
import { BulkMessagesService } from "src/app/services/misc/bulk-messages.service";
import { OrganizationService } from "src/app/services/organizationservice";
import { LeadsCustomersService } from "src/app/services/settings-services/leads-customers.service";
import { TicketService } from "src/app/services/ticket/ticket.service";
import { Endpoints } from "src/app/shared/config/endpoints";
import { AppState } from "src/app/store/app.state";
import { AllUserInfoModel, OrgModel, } from "src/app/store/storeModels/user.model";
import { AuthService } from "./../../auth/auth.service";
import { SignupLoginService } from "./../../services/signupLogin.service";
import { LocalStorageService } from "src/app/utils/LocalStorage";
// EMAIL HELPERS
import EmailHelper from "./email";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  /** */
  email_component_id: string = "header-email";
  /** */
  searchView: any;
  userDropdown: any;
  userInfo: AllUserInfoModel;
  orgList: OrgModel[] = [];
  user;
  org;
  orgID;
  userID;
  teamID;
  userImg = "/assets/img/default.png";
  userProgress;
  hidOnPrint = false;
  inputText: string;
  suggestedSearch;
  notFound: string;
  bulk_messages: any = {};
  submenuList: SubmenuI[];
  defaultOrgImg = 'https://fintechng.org/portal/assets/img/logo-default.svg'
  modules = [
    { title: 'Clients', moduleName: 'CLIENTS', link: 'clients' },
    { title: 'Targets', moduleName: 'TARGETS', link: 'target' },
    { title: 'Sales', moduleName: 'SALES', link: 'sales' },
    { title: 'Service', moduleName: 'TICKETS', link: 'ticket' },
    { title: 'Teams', moduleName: 'TEAMS', link: 'teams' },
  ]
  /** EMAIL HELPERS */
  email_helper: any;
  origin = window.location.origin;
  isA365Enabled: boolean = false;

  account_to_connect: string = "";
  connecting = {
    gmail: false,
    office: false,
    imap: false,
  };

  constructor(
    public router: Router,
    store: Store<AppState>,
    private authSrv: AuthService,
    private signSrv: SignupLoginService,
    public generalSrv: GeneralService,
    private chatSrv: ChatService,
    private organisation_service: OrganizationService,
    private bulk_message_service: BulkMessagesService,
    private currencySrv: CurrencyService,
    private leadCustomerService: LeadsCustomersService,
    toastr: ToastrService,
    private ticketSrv: TicketService,
    emailService: EmailService,
    private teamSrv: TeamsService,
    private localStorage: LocalStorageService,
    private emailSrv: EmailService,
    private emailClientService: EmailClientService,
    private endpoints: Endpoints,
    private toaster: ToastrService,
    private http: HttpClient
  ) {
    store.select("userInfo").subscribe((data) => {
      this.org = data.organization;
      this.orgID = data.organization.id;
      if (data.user) {
        this.user = data.user;
        this.userInfo = data ? data : null;
        this.userID = data.user.id;
        this.teamID = data.user.teamID;
        this.userImg =
          data && data.user && data.user.userImg
            ? data.user.userImg
            : this.userImg;
      }
    });
    this.generalSrv.printActivated.subscribe((res) => (this.hidOnPrint = res)); // Apply CSS when Print button is activated for Page

    // EMAIL HELPER
    const toast = toastr;
    this.email_helper = new EmailHelper(emailService, toast);
  }

  async ngOnInit() {
    window.addEventListener("pinc:conn:pass", () => this.save_sso_data_to_db());
    window.addEventListener(
      "pinc:conn:fail",
      () => (this.connecting[this.account_to_connect] = false)
    );
    this.getCompanyIntegration();
    this.email_helper.retrieve_connected_account();
    this.getData();
    // this.getUserProfilePercent();
    this.getOrgCurrency();
    // this.getOrgModules();
    await this.onReload();
    this.setup_organisation_sales_defaults();
    this.handle_direct_lead_source_creation();
    this.getTicketTypes();
    this.generalSrv.reloadBulkSMSApi.subscribe(res => {
        this.getBulkMessagesStatus();
    })
  }
  onImgError(event, defimg) {
    event.target.src = defimg
  }

  save_sso_data_to_db(): any {
    const data = {
      service: this.account_to_connect,
      user_id: this.userID,
      org_id: this.orgID,
    };

    this.connecting[this.account_to_connect] = true;
    this.emailSrv.saveAccessTokenOnServer({ ...data }).subscribe(
      (response: any) => {
        this.connecting[this.account_to_connect] = false;
        if (response.success) {
          this.emailSrv.user_data.next({ ...response.payload });
          this.email_helper.retrieve_account();
          this.handle_email_lead_source_creation();
        } else {
          this.toaster.error("Could not connect account.");
        }
      },
      (error) => {
        this.connecting[this.account_to_connect] = false;
      }
    );
  }

  handle_email_lead_source_creation() {
    this.leadCustomerService
      .filter_organisation_lead_sources(`name=Email`)
      .subscribe((response: any) => {
        if (response.success && !response.payload.length) {
          this.leadCustomerService
            .create_organisation_lead_source({ name: "Email" })
            .subscribe(() => {});
        }
      });
  }

  setup_organisation_sales_defaults() {
    this.organisation_service
      .createDefaultClientTemplates()
      .subscribe(() => { });
    this.organisation_service.addSalesStat().subscribe(() => { });
  }

  getTicketTypes() {
    this.ticketSrv.fetchTicketTypes().subscribe((res: any[]) => {
      this.generalSrv.ticketTypeList$.next(res);
    });
  }

  async onReload() {
    this.generalSrv.reloadComponent.subscribe(async (value) => {
      if (value) {
        // Reload Windows
        await new Promise((resolve) =>
          setTimeout(() => {
            // this.ngOnInit();
            window.location.reload();
            // resolve();
          }, 1000)
        );
        this.generalSrv.reloadComponent.next(false);
      }
    });
  }

  setUser() {
    localStorage.setItem("currentUser", JSON.stringify(this.userInfo));
  }

  setTrue() {
    this.generalSrv.reloadComponent.next(true);
  }

  getData() {
    if (this.userInfo) {
      this.getAllUserOrgs();
    }
  }

  getBulkMessagesStatus() {
    this.bulk_message_service.getCompanyIntegrations().subscribe((response) => {
      this.bulk_messages = { ...response };
    });
  }

  displaySpinner(moduleName: string) {
    // this.generalSrv.displaySpinner(moduleName);
  }

  toggleSubMenu(modul: string) {
    this.submenuList = Menus[modul];
    this.generalSrv.getSubmenEl.classList.remove("d-none");
  }

  searchToggle() {
    document.getElementById("searchBoxForm").classList.toggle("d-none");
    document.getElementById('text-focus').focus();
    return;
  }

  logout() {
    this.generalSrv.showSpinner.next(true);
    this.signSrv.logoutUser().subscribe()
      .add(() => {
        this.chatSrv.disconnect_online_agent();
        this.authSrv.logout();
        this.router.navigate(["/login"]).then(() => {
          window.location.reload();
        });
        this.generalSrv.showSpinner.next(false);
      });
  }

  getAllUserOrgs() {
    this.signSrv
      .fetchAllUserOrg(this.userInfo.user.id, 1)
      .subscribe((orgs: any[]) => {
        this.orgList = orgs.filter(
          (org) => org.id !== this.userInfo.organization.id
        );
      });
  }

  getOrgModules() {
    this.signSrv.fetchLicenseByName().subscribe((res: any) => {
      const modules = res.modules;
      this.authSrv.updateOrg({ modules });
    });
  }

  getUserProfilePercent() {
    this.signSrv.fetchUserPercent().subscribe((res) => {
      this.userProgress = res + "%";
    });
  }
  private successSwitchTenant(data) {
    this.signSrv.successLoginActionSrv(data).subscribe((resp) => {
      this.authSrv.storeUser({ ...data, ...resp });
      this.router.navigate(["/dashboard"]).then(() => {
        window.location.reload();
        this.chatSrv.joinOnlineAgents();
        this.localStorage.deleteFromLocalStorage('customerchat-ticketCode');
      });
    }, err => {
      this.generalSrv.sweetAlertError('Error occured, try again!')
    })
  }
  switchTenant(org) {
    this.generalSrv
      .sweetAlertUpdates("Switch To " + org.name)
      .then((result) => {
        if (result.value) {
          this.chatSrv.disconnect_online_agent();
          this.generalSrv.showSpinner.next(true);
          this.signSrv.switchTenant(org.id).subscribe((data: any) => {
            this.getAllUserOrgs();
            this.getOrgCurrency();
            this.successSwitchTenant(data);
          }, (err) => {
            const status = err.error && err.error.status ? err.error.status : '';
            const error = this.generalSrv.getErrMsg(err);
            if (status === 'INACTIVE_PLAN') {
              const upx = `<h6><b>${error}</b></h6>` + '<p>Do you want to purchase a new license for this organization?</p>'
              this.generalSrv.sweetAlertUpdates(upx).then((rexx) => {
                if (rexx.value) {                 
                  localStorage.setItem("organization", JSON.stringify(org));
                  this.router.navigate(["/reg/plans"]);
                  // const datax = { ...err.error, organization: org };
                  // const query = { page: 'switchTenant', data: JSON.stringify(datax) }
                  // this.router.navigate(['/login'], { queryParams: query })
                }
              })
            } else {
              this.generalSrv.sweetAlertError(error)
            }
          }
          )
            .add(() => {
              this.generalSrv.showSpinner.next(false);
            });
        }
      });
  }

  getOrgCurrency() {
    this.currencySrv.fetch_organisation_currencies().subscribe((res: any) => {
      if (res.success && res.payload.length) {
        const formatted_currencies = this.currencySrv.format_db_currency_data_for_client(
          res.payload[0].currencies
        );
        this.currencySrv.org_currencies.next({
          id: res.payload[0].id,
          base_currency:
            res.payload[0] && res.payload[0].currencies.length > 0
              ? res.payload[0].currencies[0].base_currency
              : "",
          currencies: formatted_currencies,
        });
        localStorage.setItem("baseCurrency", res.payload[0] && res.payload[0].currencies.length > 0
          ? res.payload[0].currencies[0].base_currency
          : "USD");
      }
    });
  }

  handle_direct_lead_source_creation() {
    this.leadCustomerService
      .filter_organisation_lead_sources(`name=Direct`)
      .subscribe(
        (response: any) => {
          if (response.success && !response.payload.length) {
            this.leadCustomerService
              .create_organisation_lead_source({ name: "Direct" })
              .subscribe(() => { });
          }
        },
        (err) => this.generalSrv.sweetAlertError(err.message)
      );
  }

  handleUserToggle() {
    const dropdown = $("#dropdown1");
    if (dropdown.hasClass("showDropDown")) {
      dropdown.removeClass("showDropDown");
    } else {
      dropdown.addClass("showDropDown");
    }
    // this.userDropdown
    //   ? (this.userDropdown = false)
    //   : (this.userDropdown = true);
  }

  //SEARCH

  /**
   * Get organization clients
   */
  getSuggestions() {
    this.notFound = '';
    setTimeout(() => {
      const value = this.inputText.trim();
      if (!value) {
        this.clearSuggestedUsers();
        return;
      }
      const query = `page=0&population=10`;

      const leads_lookup = this.emailClientService.fetchClientsByWildcard(
        value,
        "leads",
        query
      );

      const contacts_lookup = this.emailClientService.fetchClientsByWildcard(
        value,
        "contacts",
        query
      );

      const companies_lookup = this.emailClientService.fetchClientsByWildcard(
        value,
        "companies",
        query
      );

      const users_lookup = this.signSrv.searchUsers(value);

      const teams_lookup = this.teamSrv.searchTeam(value);

      forkJoin([leads_lookup, contacts_lookup, companies_lookup, users_lookup, teams_lookup,
      ]).subscribe((responses: any) => {
        let suggested_users = [];

        if (responses[0].success) {
          suggested_users = [...suggested_users, ...responses[0].payload];
        }

        if (responses[1].success) {
          suggested_users = [...suggested_users, ...responses[1].payload];
        }

        if (responses[2].success) {
          suggested_users = [...suggested_users, ...responses[2].payload];
        }

        if (responses[3]) {
          suggested_users = [...suggested_users, ...responses[3]];
        }

        if (responses[4]) {
          suggested_users = [...suggested_users, ...responses[4]];
        }

        const needle = this.inputText.trim();

        const validSuggestions = [];
        suggested_users.forEach(user => {
          const record = user.user ? { ...user.user, ...user.userRel } : user;
          if (
            (record.name && (record.name.toLowerCase()).includes(needle)) ||
            (record.firstName && (record.firstName.toLowerCase()).includes(needle)) ||
            (record.lastName && (record.lastName.toLowerCase()).includes(needle)) ||
            (record.teamName && (record.teamName.toLowerCase()).includes(needle)) ||
            (record.userEmail && (record.userEmail.toLowerCase()).includes(needle)) ||
            (record.phoneNumber && (record.phoneNumber.toLowerCase()).includes(needle)) ||
            (record.officialPhoneNumber && (record.officialPhoneNumber.toLowerCase()).includes(needle)) ||
            (record.personalPhoneNumber && (record.personalPhoneNumber.toLowerCase()).includes(needle)) ||
            (record.email && (record.email.toLowerCase()).includes(needle))
          ) {
            validSuggestions.push(record);
          }
        });
        this.suggestedSearch = needle ? [...validSuggestions] : [];
      });
    }, 500);
  }

  clearSuggestedUsers() {
    this.suggestedSearch = [];
  }

  /**
   * Navigate to the various path
   * @param search
   */
  handleNSearchNav(search, inputName) {
    if (search.type === "lead") {
      window.location.replace("/clients/leads/" + search.id);
      this.inputText = "";
      this.searchToggle();
    } else if (search.type === "company") {
      window.location.replace("/clients/companies-view/" + search.id);
      this.inputText = "";
      this.searchToggle();
    } else if (search.type === "contact") {
      window.location.replace("/clients/contacts-view/" + search.id);
      this.inputText = "";
      this.searchToggle();
    } else if (search.teamName) {
      window.location.replace("/teams/team/" + search.teamID);
      this.inputText = "";
      this.searchToggle();
    } else if (search.salesPerson == true) {
      window.location.replace("/teams/saleperson/" + search.user.id);
      this.inputText = "";
      this.searchToggle();
    }
    this.clearSuggestedUsers();
    this.clearInputText(inputName);
  }

  clearInputText(inputName) {
    this[inputName] = "";
  }

  // DEMO Account Navigation Handler
  async handleDemoCreationPrompt() {
    const createDemoResult = await this.organisation_service.createDemoOrg(this.orgID, this.teamID, this.userID);
    const { apiKey, agent, organization, priviledges, roleName, salesperson, supervisor, token, user, team, modules, resources } = createDemoResult;

    const queryPayload = {
      apiKey,
      isAgent: agent,
      isSalesperson: salesperson,
      organization: { ...organization, modules, resources },
      priviledges,
      roleName,
      supervisor,
      token,
      user: { ...user, teamID: team.id }
    }
    const { user: { id: userID, teamID }, organization: { id: orgID } } = queryPayload;

    const result = await this.organisation_service.getOrganizationDemoDBStatus(orgID);
    const { status } = result;
    if (status === 'NO_DATA_PRESENT' || status === null) {
      this.generalSrv.swtAlertDynoPrompt('Demo Account', 'Create Demo Account', 'With Dummy Data', 'Without Dummy Data')
        .then(response => {
          if (response.value) {
            this.organisation_service.createDummyData(orgID, teamID, userID).subscribe(res => {
              if (res.stauts = "SUCCESS") {
                window.open(`https://demo.notchcx.io/demoloader?${JSON.stringify(queryPayload)}`, '_blank');
              }
            })
          } if (response.dismiss.toString() == 'cancel') {
            window.open(`https://demo.notchcx.io/demoloader?${JSON.stringify(queryPayload)}`, '_blank');
          }
        });
    } else {
      window.open(`https://demo.notchcx.io/demoloader?${JSON.stringify(queryPayload)}`, '_blank');
    }

  }
  
  getCompanyIntegration(){
    const org = this.org;
    const api = this.endpoints.settingsApi;
    this.isA365Enabled = false;
    this.http.get(api + `/${org.id}/getIntegrationsByCompany`).subscribe((res: any) => {
      if(res && res.a365Enabled){
        this.isA365Enabled = true;
      }else{
        this.isA365Enabled = false;
      }
    });
  }
}
